export default __webpack_public_path__ + "static/media/TheMixC5-5iPlainItalic.0cb6d1a3.woff2";